export const getDateText = (dateString: string): string => {
  const x = new Date(dateString)
  const date = x.getDate()
  const month = x.toLocaleString('default', { month: 'short' })
  const year = x.getFullYear()
  return `${date}\u00A0${month}\u00A0${year}`
}

export const getTimeText = (dateString: string): string => {
  const x = new Date(dateString)
  const hour = x.getHours()
  const minute = x.getMinutes()
  // add leading zero
  const hourStr = hour < 10 ? `0${hour}` : `${hour}`
  const minuteStr = minute < 10 ? `0${minute}` : `${minute}`
  return `${hourStr}:${minuteStr}`
}

export const getDateTimeString = (date: Date | string) => {
  if (!date) {
    return ''
  }
  // console.log('date', date)
  if (!(date instanceof Date)) {
    // console.log('date is not instance of Date')
    date = new Date(date)
  }
  // convert date to format: 6 Feb 2024 09:16
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // Ensures the time is in 24-hour format
  })
}
